import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)
export default new Vuex.Store({

    state: {
        dashboardHash: "0",
        dashboardData: null,
        dashboardConfig: {components:[]}
    },
    mutations: {
        setDashboardHash: (state, payload) => {
            state.dashboardHash = payload
        },
        setDashboardData: (state, payload) => {
            state.dashboardData = payload
        },
        setDashboardConfig: (state,payload)=>{
            state.dashboardConfig = payload
        }

    },
    getters: {
        getDashboardHash: (state) => {
            return state.dashboardHash
        },
        getDashboardData: (state) => {

            return state.dashboardData
        },
        getDashboardConfig: (state ) =>{
            return state.dashboardConfig
        },
        getDashboardComponents: (state) => {
                return state.dashboardConfig.components
        },
        getComponentConfig:(state) => (id) => {
            var config = state.dashboardConfig.components.find(comp => comp.id == id).configuration


            return JSON.parse(config)
        }

    },
    actions: {
        // getScreenData: ({state, commit, dispatch}) => {
        //     DATA_API.get('/dashboard/screen').then(res => {
        //         if (res.status === 200) {
        //             commit('setScreenData', res.data)
        //         }
        //     })
        // },

    },
    modules: {},
    plugins: [],
})
